const mutationsSubscribeNames = [
  'setInputValue',
]

function getInitState() {
  return {
    muted: false,
    inputs: {
      comment: {
        value: null
      }
    }
  }
}

export default {
  namespaced: true,
  state: {
    ...getInitState(),
    mutationsSubscribeNames
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setInputValue(state, {key, value}) {
      if (!state.inputs.hasOwnProperty(key)) return
      state.inputs[key].value = value
    }
  },
  actions: {
    setVacancyValues({commit}, vacancy) {
      commit('setInputValue', {key: 'comment', value: vacancy.char_additional_info})

      commit('setMuted', false)
    }
  }
}
